import React from 'react';
import Invoice from './Invoice';
import { printCurrency } from '../util/formatUtility'
import { translateResourceString } from '../util/translationUtility';

class InvoiceList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
        };
    }

    handleSelectAll = (event) => {
        this.props.invoices.forEach(invoice => this.props.setInvoiceSelected(invoice.OpenARId, event.target.checked));
    }

    renderInvoice = (i) => {
        return (
            <Invoice key={this.props.invoices[i].OpenARId}
                data={this.props.invoices[i]}
                setSelected={this.props.setInvoiceSelected}
                setAmountToPay={this.props.setInvoiceAmountToPay}
                useSummaryView={this.props.useSummaryView}
            />

        );
    }

    render() {
        const {
            invoices,
            useSummaryView,
            invoicesTotal,
            navigateToView
        } = this.props;

        const invoicesRender = invoices.map((x, i, y) => this.renderInvoice(i), this);

        const dNoneInSummaryView = useSummaryView ? "d-none" : "";

        const disablePayButton = invoicesTotal < 0 || !invoices || invoices.length === 0 || invoices.filter(i => i.isSelected && i.Balance > 0).length === 0;

        return (
            <React.Fragment>
                <div className="form-group-sm">
                    <div className="table-responsive">
                        <table className="table table-striped invoice-table text-sm input-container">
                            <thead>
                                <tr>
                                    <th scope="col" className={dNoneInSummaryView}><input type="checkbox" onChange={this.handleSelectAll}/></th>
                                    <th scope="col">{translateResourceString("/MyAccountPage/InvoicePayments/CustomerNumberNameAddressHeadding")}</th>
                                    <th scope="col">{translateResourceString("/MyAccountPage/InvoicePayments/AddlReferenceNumberHeading")}</th>
                                    <th scope="col" className={dNoneInSummaryView}>{translateResourceString("/MyAccountPage/InvoicePayments/NotesHeading")}</th>
                                    <th scope="col" className={dNoneInSummaryView}>{translateResourceString("/MyAccountPage/InvoicePayments/TransactionTypeHeading")}</th>
                                    <th scope="col" className={dNoneInSummaryView}>{translateResourceString("/MyAccountPage/InvoicePayments/DateHeading")}</th>
                                    <th scope="col" className={dNoneInSummaryView}>{translateResourceString("/MyAccountPage/InvoicePayments/DueDateHeading")}</th>
                                    <th scope="col">{translateResourceString("/MyAccountPage/InvoicePayments/BalanceHeading")}</th>
                                    {/*<th scope="col">*/}
                                    {/*    {useSummaryView*/}
                                    {/*        ? translateResourceString("/MyAccountPage/InvoicePayments/PaymentHeading")*/}
                                    {/*        : translateResourceString("/MyAccountPage/InvoicePayments/AmountToPayHeading")*/}
                                    {/*    }*/}
                                    {/*</th>*/}
                                    {/*<th scope="col" className={dNoneInSummaryView}>{translateResourceString("/MyAccountPage/InvoicePayments/RemainingBalanceHeading")}</th>*/}
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="d-none"></tr> {/* This changes the color alternations to have light first */}
                                {invoicesRender}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="text-right">
                    {
                        <h2>
                            {translateResourceString("/MyAccountPage/InvoicePayments/TotalPaymentLabel")} {printCurrency(invoicesTotal)}
                        </h2>
                    }
                    {!useSummaryView &&
                        <button
                            disabled={disablePayButton}
                            className="btn btn-cc-black"
                            onClick={() => navigateToView(1)}
                        >
                            {translateResourceString("/MyAccountPage/InvoicePayments/PayInvoicesButton")}
                        </button>
                    }
                    {invoicesTotal < 0 &&
                        <p className="color-red">{translateResourceString("/MyAccountPage/InvoicePayments/NegativeAmountMessage")}</p>
                    }
                </div>



            </React.Fragment>
        );
    }
}

export default InvoiceList;